import React, { useCallback, useMemo } from 'react';
import { Button, Col, FormGroup, Input, InputGroup, InputGroupAddon, Label } from 'reactstrap';
import PropTypes from 'prop-types';

const LinhaCopiavel = ({ titulo, valor, mostrarSucesso }) => {
    const identificador = useMemo(() => {
        const slug = titulo.replace(/\s/g, '_').normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return `${slug}_${Math.random()}`;
    }, [titulo]);

    const copiarParaAreaDeTransferencia = useCallback(async () => {
        await navigator.clipboard.writeText(valor);
        if(mostrarSucesso){
            mostrarSucesso(`Copiado com sucesso: ${valor}`);
        }
    }, [valor, mostrarSucesso]);

    if (!valor) return null;

    return (
        <FormGroup row>
            <Col>
                <Label for={identificador}>{titulo}</Label>
            </Col>
            <Col xs="9">
                <InputGroup>
                    <Input readOnly type="text" value={valor} id={identificador} />
                    <InputGroupAddon addonType="append">
                        <Button onClick={copiarParaAreaDeTransferencia} color="link">
                            <i className="ecoico ecoico-content-copy" /> Copiar
                        </Button>
                    </InputGroupAddon>
                </InputGroup>
            </Col>
        </FormGroup>
    );
};

LinhaCopiavel.propTypes = {
    titulo: PropTypes.string.isRequired,
    valor: PropTypes.string.isRequired,
    mostrarSucesso: PropTypes.func,
};

export default LinhaCopiavel;
